import Box from '@mui/material/Box'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import { useMediaQuery } from 'react-responsive'

const ProfileTabs = ({ tab, handleChange }) => {
  const a11yProps = index => {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    }
  }
  const isMobileOrTablet = useMediaQuery({
    query: '(max-width: 800px)',
  })

  return (
    <Box>
      <Tabs
        value={tab}
        onChange={handleChange}
        aria-label="scrollable auto tabs example"
        className="h-[50px] !text-over-secondary-background !bg-secondary-background border border-[#c2bfbf] p-0"
        TabIndicatorProps={{
          sx: {
            backgroundColor: 'rgb(var(--ternary-background))',
          },
        }}
      >
        <Tab
          sx={{ color: 'rgb(var(--over-secondary-background)) !important' }}
          disableRipple
          label="Date generale"
          {...a11yProps(0)}
          className={`isMOBILEorTablet ${
            isMobileOrTablet ? 'text-[15px]' : 'text-[18px]'
          }`}
        />
        <Tab
          sx={{ color: 'rgb(var(--over-secondary-background)) !important' }}
          disableRipple
          label="Date facturare"
          {...a11yProps(1)}
          className={`isMOBILEorTablet ${
            isMobileOrTablet ? 'text-[15px]' : 'text-[18px]'
          }`}
        />
      </Tabs>
    </Box>
  )
}

export default ProfileTabs
